var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stars-wrapper",attrs:{"title":_vm.value+'%'}},[_c('div',{staticClass:"stars"},[_c('div',{staticClass:"stars-back",style:({ width: _vm.value + '%' })})])])}
var staticRenderFns = []

export { render, staticRenderFns }